var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useMemo } from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet, Loader, useStyleSheet } from '@gopeerproject/ui-kit';
import { Indicators, Titles, Days } from './components';
const weekdays = moment.weekdays();
export const TutorSchedule = (_a) => {
    var { style, timezone: tz = 'America/New_York' } = _a, props = __rest(_a, ["style", "timezone"]);
    const styles = useStyleSheet(getStyles);
    const timezone = tz || 'America/New_York';
    const startHour = useMemo(() => {
        if (props.isLoading)
            return 8;
        let min = 23;
        props.data.forEach((day) => {
            day.forEach((entry) => {
                const hour = moment(entry.from).tz(timezone).startOf('hour').hour();
                if (hour < min)
                    min = hour;
            });
        });
        return min;
    }, [props.isLoading, props.data, timezone]);
    const endHour = useMemo(() => {
        if (props.isLoading)
            return 8;
        let max = 0;
        props.data.forEach((day) => {
            day.forEach((entry) => {
                const hour = moment(entry.to).tz(timezone).startOf('hour').hour() + 1;
                if (hour > max)
                    max = hour;
            });
        });
        return max;
    }, [props.isLoading, props.data, timezone]);
    const schedule = useMemo(() => {
        const numOfMinutes = (endHour - startHour) * 60;
        const output = weekdays.reduce((prev, cur) => (Object.assign(Object.assign({}, prev), { [cur]: [] })), {});
        if (props.isLoading)
            return output;
        for (const [index, day] of props.data.entries()) {
            const now = moment().format('MM-DD-YYYY');
            const startOfDay = moment().startOf('day').add(startHour, 'hours');
            output[weekdays[index]] = day.map((v) => {
                const from = moment(v.from).tz(timezone).format('HH:mm');
                const to = moment(v.to).tz(timezone).format('HH:mm');
                const start = moment(now + from, 'MM-DD-YYYY HH:mm');
                const end = v.to === '00:00'
                    ? moment().add(1, 'day').startOf('day')
                    : moment(now + to, 'MM-DD-YYYY HH:mm');
                let top = (start.diff(startOfDay, 'minutes') / numOfMinutes) * 100;
                let height = (end.diff(start, 'minutes') / numOfMinutes) * 100;
                if (top < 0) {
                    height += top;
                    top = 0;
                }
                if (top + height > 100) {
                    height = 100 - top;
                }
                return Object.assign(Object.assign({ top, height }, v), { from, to });
            });
            output[weekdays[index]].sort((a, b) => a.top - b.top);
        }
        return output;
    }, [props.isLoading, props.data, startHour, endHour, timezone]);
    return props.isLoading ? (React.createElement(Loader, { full: true })) : (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Titles, null),
        React.createElement(View, { style: styles.wrapper },
            React.createElement(Indicators, { startHour: startHour, endHour: endHour }),
            React.createElement(Days, { data: schedule }))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    wrapper: {
        width: '100%',
        flex: 1,
        flexDirection: 'row',
        marginLeft: size.C,
        paddingBottom: size.C
    }
}));
//# sourceMappingURL=index.js.map